import React from 'react'
import { graphql } from 'gatsby'
import Helmet from 'react-helmet'
import { useLocation } from '@reach/router'
import Layout from '../components/layout'
import WpAuthor from '../components/WpAuthor'
import { mapLocaleData } from '../utils'

const AuthorTemplate = ({ data }) => {
  const siteTitle = data.site.siteMetadata.title
  const navBarData = data.contentfulNavigationBar
  const footerData = data.contentfulFooterV2
  const authorData = data.wpAuthor
  const authorPosts = data.allWpPost.edges
  const defaultdata = data.wp.generalSettings
  const siteLanguages = data.site.siteMetadata.languages
  const latestBlogPost = data.latestPost.edges[0].node
  const location = useLocation()

  return (
    <Layout
      latestBlogPost={latestBlogPost}
      navBarData={navBarData}
      footerData={footerData}
      siteLanguages={siteLanguages}
      location={location}
    >
      <div style={{ background: '#fff' }}>
        <Helmet title={siteTitle} />
        <WpAuthor
          data={authorData}
          defaultdata={defaultdata}
          location={location}
          authorPosts={authorPosts}
        />
      </div>
    </Layout>
  )
}

export default AuthorTemplate

export const pageQuery = graphql`
  fragment authorNode on WpAuthor {
    id
    title
    locale {
      locale
      id
    }
    slug
    authorDetails {
      detailedBio
      jobTitle
      socialLinks {
        linkedinUrl
        twitterUrl
      }
      bannerImage {
        localFile {
          childImageSharp {
            gatsbyImageData(
              transformOptions: { cropFocus: CENTER }
              layout: FULL_WIDTH
            )
          }
          publicURL
        }
        altText
      }
      profilePicture {
        localFile {
          childImageSharp {
            gatsbyImageData(
              width: 168
              height: 168
              transformOptions: { cropFocus: CENTER }
              layout: CONSTRAINED
            )
          }
          publicURL
        }
        altText
      }
    }
  }

  query ($id: ID!, $authorId: String!) {
    site {
      siteMetadata {
        title
        languages {
          defaultLangKey
          langs
        }
      }
    }

    latestPost: allWpPost(
      sort: { fields: date, order: DESC }
      limit: 1
      filter: { locale: { locale: { eq: "en_US" } }, status: { eq: "publish" } }
    ) {
      edges {
        node {
          ...LatestPost
        }
      }
    }

    contentfulNavigationBar(node_locale: { eq: "en-US" }) {
      ...ContentfulNavQuery
    }

    wp {
      ...GeneralSettings
    }

    allWpPost(
      filter: { authorId: { eq: $id }, locale: { locale: { eq: "en_US" } } }
    ) {
      edges {
        node {
          ...previewCardQuery
        }
      }
    }

    wpAuthor(id: { eq: $authorId }, locale: { locale: { eq: "en_US" } }) {
      ...authorNode
    }

    contentfulFooterV2(node_locale: { eq: "en-US" }) {
      ...ContentfulFooterQuery
    }
  }
`
